'use client'
import queries from '../api/queries'
import useQueryParams from '@/shared/routing/use-query-params'
import { useEffect } from 'react'

const targetParam = 'confirmemail'

const useConfirmEmailCodeHandler = () => {
  const { mutate, isSuccess, isError } = queries.useConfirmEmail()
  const { params } = useQueryParams()
  const code = params.get(targetParam)

  useEffect(() => {
    if (!!code) mutate({ code })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  useEffect(() => {
    if (isSuccess) params.delete(targetParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess])

  useEffect(() => {
    if (isError) params.delete(targetParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError])
}

export default useConfirmEmailCodeHandler
